import React, { useState, useEffect } from "react";

import {
  Card,
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { styles } from "../theme/styles";
import { Creators as StoresCreators } from "../store/ducks/stores";
import { Creators as ProvidersCreators } from "../store/ducks/providers";
import { connect } from "react-redux";
import { CustomButton } from "./CustomButton";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import SnackBar from "../components/SnackBarCustom";
import reportes from "../assets/reportes.png";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import * as L from "leaflet";
import * as turf from "@turf/turf";
const ReportesForm = (props) => {
  const {
    stores,
    providers,
    token,
    downloadInventoryProviders,
    downloadInventory,
    downloadCSVOrderGlobal,
    loadingProviders,
    loadingGlobal,
    loadingStores,
    message,
    clearMessage,
  } = props;
  const [currentWeek, setCurrentWeek] = useState(getWeekNumber(new Date()));
  const [selectedWeek, setSelectedWeek] = useState(currentWeek);
  const [dateRange, setDateRange] = useState(
    getCurrentWeekInfo(currentWeek).dateRange
  );
  const [puntos, setPuntos] = useState([]);
  const [estados, setEstados] = useState([]);
  const manejarDobleClick = (event) => {
    const { lat, lng } = event.latlng;
    setPuntos((prevPuntos) => [
      ...prevPuntos,
      { lat, lng, mensaje: "Ubicación personalizada" },
    ]);
  };
  const estiloEstados = (index) => ({
    color: "#000",
    weight: 0,
    fillOpacity: 0.5,
    fillColor: colores[index % colores.length],
  });
  const onEachFeature = (feature, layer) => {
    layer.bindPopup(`Bienvenido a ${feature.properties.NOM_ENT || "Estado"}`);
  };
  // useEffect(() => {
  //   const cargarEstados = async () => {
  //     const nombresEstados = [
  //       "Aguascalientes",
  //       "Zacatecas",
  //       "Ciudad de México",
  //     ];
  //     const estadosCargados = [];
  //     for (const nombre of nombresEstados) {
  //       try {
  //         const response = await fetch(`/states/${nombre}.json`);
  //         const data = await response.json();
  //         console.log("data: ", data);
  //         estadosCargados.push(data);
  //       } catch (error) {
  //         console.error(`Error cargando ${nombre}.json`, error);
  //       }
  //     }
  //     setEstados(estadosCargados);
  //   };
  //   cargarEstados();
  // }, []);
  const colores = [
    "#ffadad",
    "#ffd6a5",
    "#fdffb6",
    "#caffbf",
    "#9bf6ff",
    "#a0c4ff",
    "#bdb2ff",
    "#ffc6ff",
  ];
  function getWeekNumber(date) {
    date = date || new Date();
    const currentDate = new Date(date);
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(
      currentDate.getDate() + 4 - (currentDate.getDay() || 7)
    );
    const yearStart = new Date(currentDate.getFullYear(), 0, 1);
    const weekNumber = Math.ceil(
      ((currentDate - yearStart) / 86400000 + 1) / 7
    );
    return weekNumber;
  }
  const customIcon = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/25/25694.png",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
  });
  // function getWeekStartDate(week, year) {
  //   const startDayOfWeek = 1;
  //   const januaryFirst = new Date(year, 0, 1);
  //   const januaryFirstDayOfWeek = januaryFirst.getDay();
  //   const daysToSubtract = (startDayOfWeek - januaryFirstDayOfWeek + 7) % 7;
  //   const startDate = new Date(year, 0, 1 + 7 * (week - 1) + daysToSubtract);
  //   return startDate;
  // }
  // function getWeekEndDate(week, year) {
  //   const startDate = getWeekStartDate(week, year);
  //   const endDate = new Date(startDate);
  //   endDate.setDate(startDate.getDate() + 6);
  //   return endDate;
  // }
  function getWeekStartDate(week, year) {
    const jan4 = new Date(year, 0, 4); 
    const dayOfWeek = jan4.getDay() || 7;
    const dayOffset = 1 - dayOfWeek;
    const mondayOfWeek1 = new Date(jan4);
    mondayOfWeek1.setDate(jan4.getDate() + dayOffset);
  
    const result = new Date(mondayOfWeek1);
    result.setDate(mondayOfWeek1.getDate() + (week - 1) * 7);
    return result;
  }
  
  function getWeekEndDate(week, year) {
    const start = getWeekStartDate(week, year);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    return end;
  }
  
  function getCurrentWeek() {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    const days = Math.floor((now - startOfYear) / 86400000);
    const weekNumber = Math.ceil((days + startOfYear.getDay() + 1) / 7);
    return weekNumber;
  }
  const currentWeekToday = getCurrentWeek();
  const handleChangeWeek = (e) => {
    const newWeek = parseInt(e.target.value, 10);
    setSelectedWeek(newWeek);
  };
  const handlePreviousWeek = () => {
    const previousWeek = currentWeek - 1;
    setCurrentWeek(previousWeek);
    setSelectedWeek(previousWeek);
  };
  const handleNextWeek = () => {
    const nextWeek = currentWeek + 1;
    setCurrentWeek(nextWeek);
    setSelectedWeek(nextWeek);
  };
  const handleStock = (event) => {
    event.preventDefault();

    if (stores && stores.includes && token) {
      if (isCurrentWeek) {
        downloadInventory(token, null);
      } else {
        downloadInventory(token, currentWeek);
      }
    } else {
      console.error("Error ");
    }
  };
  const handleProviders = (event) => {
    event.preventDefault();

    if (providers && providers.includes && token) {
      if (isCurrentWeek) {
        downloadInventoryProviders(token, null);
      } else {
        downloadInventoryProviders(token, currentWeek);
      }
    } else {
      console.error("Error ");
    }
  };
  const handleReporteGlobal = (event) => {
    event.preventDefault();

    if (token) {
      downloadCSVOrderGlobal(token);
    } else {
      console.error("Error");
    }
  };
  const isCurrentWeek = getWeekNumber(new Date()) === currentWeek;
  function getCurrentWeekInfo(week) {
    const year = new Date().getFullYear();
    const startDate = getWeekStartDate(week, year);
    const endDate = getWeekEndDate(week, year);


    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };
    const startDateString = formatDate(startDate);
    const endDateString = formatDate(endDate);
    const dateRange = `${startDateString} - ${endDateString}`;
    return {
      dateRange,
    };
  }
  useEffect(() => {
    console.log(selectedWeek)
    setCurrentWeek(selectedWeek);
    setDateRange(getCurrentWeekInfo(selectedWeek).dateRange);
  }, []);
  return (
    <div style={styles.content}>
      <div style={styles.divCenter}>
        {/* <Box style={styles.semana}>
        <p>Selecciona una semana:&nbsp;</p>
        <FormControl>
          <Select
            labelId="weekSelectLabel"
            id="weekSelect"
            value={selectedWeek}
            onChange={handleChangeWeek}>
            {Array.from({ length: currentWeekToday }, (_, i) => (
              <MenuItem key={i + 1} value={i + 1}>{`${i + 1}`}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box> */}
        <Card style={styles.contenedorRepo} variant="outlined">
          <Typography variant="h5" color="primary" style={styles.reportestitle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-report-search"
              width="36"
              height="36"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="#00205b"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697" />
              <path d="M18 12v-5a2 2 0 0 0 -2 -2h-2" />
              <path d="M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
              <path d="M8 11h4" />
              <path d="M8 15h3" />
              <path d="M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0" />
              <path d="M18.5 19.5l2.5 2.5" />
            </svg>{" "}
            Reportes
          </Typography>
          {/* {!isCurrentWeek && (
              // <svg
              //   xmlns="http://www.w3.org/2000/svg"
              //   className="icon icon-tabler icon-tabler-square-rounded-arrow-right-filled"
              //   width="36"
              //   height="36"
              //   viewBox="0 0 24 24"
              //   strokeWidth="1.5"
              //   stroke="#00205b"
              //   fill="none"
              //   strokeLinecap="round"
              //   onClick={handleNextWeek}
              //   strokeLinejoin="round"
              // >
              //   <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              //   <path
              //     d="M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm.613 5.21l.094 .083l4 4a.927 .927 0 0 1 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-4 4a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293h-5.585a1 1 0 0 1 -.117 -1.993l.117 -.007h5.585l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z"
              //     fill="#00205b"
              //     strokeWidth="0"
              //   />
              // </svg>
            )} */}

          <Typography>{`Semana ${currentWeek}`}</Typography>
          <Typography>{`${dateRange}`}</Typography>
          <div style={styles.reportSize}>
            <div style={styles.container}>
              <div style={styles.reportButtonSize}>
                {!loadingStores ? (
                  <CustomButton style={styles.repo} onClick={handleStock}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-building-store"
                      width="36"
                      height="36"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="#ffffff"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3 21l18 0" />
                      <path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4" />
                      <path d="M5 21l0 -10.15" />
                      <path d="M19 21l0 -10.15" />
                      <path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" />
                    </svg>
                    Stock de Tiendas
                  </CustomButton>
                ) : (
                  <CircularProgress />
                )}
              </div>

              <div style={styles.reportButtonSize}>
                {!loadingProviders ? (
                  <CustomButton style={styles.repo} onClick={handleProviders}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-users"
                      width="36"
                      height="36"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="#ffffff"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                      <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                    </svg>
                    Inventario Proovedores
                  </CustomButton>
                ) : (
                  <CircularProgress />
                )}
              </div>

              <div style={styles.reportButtonSize}>
                {!loadingGlobal ? (
                  <CustomButton
                    style={styles.repo}
                    onClick={handleReporteGlobal}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-world-pin"
                      width="36"
                      height="36"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="#ffffff"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M20.972 11.291a9 9 0 1 0 -8.322 9.686" />
                      <path d="M3.6 9h16.8" />
                      <path d="M3.6 15h8.9" />
                      <path d="M11.5 3a17 17 0 0 0 0 18" />
                      <path d="M12.5 3a16.986 16.986 0 0 1 2.578 9.018" />
                      <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z" />
                      <path d="M19 18v.01" />
                    </svg>
                    Reporte Global
                  </CustomButton>
                ) : (
                  <CircularProgress />
                )}
              </div>
            </div>
          </div>
          <img
            alt="Company Logo"
            src={reportes}
            style={styles.logoRep}
            variant="rounded"
          />
        </Card>
        {/* <MapContainer
          center={[23.6345, -102.5528]}
          zoom={5}
          style={{ height: "500px", width: "100%" }}
          onDblClick={manejarDobleClick}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {estados.map((estado, index) => (
            <GeoJSON
              key={`geojson-${index}`}
              data={estado}
              style={estiloEstados(index)}
              onEachFeature={onEachFeature}
            />
          ))}

          {puntos.map((punto, index) => (
            <Marker
              key={index}
              position={[punto.lat, punto.lng]}
              icon={customIcon}>
              <Popup>{punto.mensaje}</Popup>
            </Marker>
          ))}
        </MapContainer> */}
        {message ? (
          <SnackBar
            message={message.text}
            variant={message.type}
            open={message ? true : false}
            onClose={clearMessage}
            time={3000}
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stores: state.stores.stores,
    providers: state.providers.providers,
    loadingGlobal: state.stores.loadingGlobal,
    loadingStores: state.stores.loading,
    loadingProviders: state.providers.loading,
    token: state.users.uid,
    message: state.config.message,
  };
};

const mapDispatchToProps = {
  downloadInventory: StoresCreators.downloadInventory,
  downloadInventoryProviders: ProvidersCreators.downloadInventoryProviders,
  downloadCSVOrderGlobal: StoresCreators.downloadCSVOrderGlobal,
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportesForm);
